import { RootState } from "./store";

export const STORES = {
  hub: "hub",
  taskDetails: "taskDetails",
  collectionStatus: "collectionStatus",
  documents: "documents",
  emissions: "emissions",
  dataCollection: "dataCollection",
  submissionSlotDetails: "submissionSlotDetails",
};

export type StateFn<T> = (state: RootState) => T;
